<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-cash-alt"></i> &nbsp;<ng-container i18n>Homeaway Fees</ng-container></h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <div class="empty" *ngIf="!feesForm.length && !loading">
    <p i18n>No fees have been added yet.</p>
  </div>
  <app-loading-section *ngIf="loading"></app-loading-section>
  <form [formGroup]="form" *ngIf="!loading && !!feesForm.length">
    <ng-container formArrayName="fees" *ngFor="let fee of feesForm.controls; let i = index">
      <div class="row" [formGroupName]="i">
        <div class="col-3">
          <mat-form-field2 class="mat-block">
            <input matInput placeholder="Name:" i18n-placeholder formControlName="name" type="text" required />
          </mat-form-field2>
        </div>
        <div class="col-3">
          <mat-form-field2 class="mat-block">
            <input matInput placeholder="Amount" i18n-placeholder formControlName="amount" type="number" required />
          </mat-form-field2>
        </div>
        <div class="col-3">
          <mat-form-field2 class="mat-block">
            <mat-select placeholder="Type" i18n-placeholder formControlName="type" required>
              <mat-option value="pct" i18n>Percent</mat-option>
              <mat-option value="flat" i18n>Flat</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
        <div class="col-3">
          <mat-form-field2 class="mat-block">
            <mat-select placeholder="Modality" i18n-placeholder formControlName="modality" required>
              <mat-option value="ps" i18n>Per Stay</mat-option>
              <mat-option value="pn" i18n>Per Night</mat-option>
              <mat-option value="pp" i18n>Per Person</mat-option>
              <mat-option value="pppn" i18n>Per Person/Per Night (PP/PN)</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </div>
    </ng-container>
  </form>
</div>
<div class="modal-footer">
  <button (click)="close()" type="button" class="btn btn-light">
    <i class="far fa-times"></i> <ng-container i18n>Close</ng-container>
  </button>
  <button
    (click)="onEditFees()"
    type="button"
    matTooltip="Go to Fee Section in Rental section to edit this"
    i18n-matTooltip
    class="btn btn-secondary-info create-btn"
  >
    <i class="fal fa-edit"></i> <ng-container i18n>Edit Fees</ng-container>
  </button>
</div>
